// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bpmJUZCan1_o8z {
  padding: 3px var(--ds-space-0, 0);
}
.YxJmedNdfd6NHO {
  margin-bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disclaimerMessage": `bpmJUZCan1_o8z`,
	"addToWorkspaceButton": `YxJmedNdfd6NHO`
};
export default ___CSS_LOADER_EXPORT___;
